<div
  class="flex w-full items-start justify-between p-4 md:p-8 border-b border-gray-200 md:border-0"
>
  <button type="button" [routerLink]="['/']">
    <img
      [src]="assetUrl + 'icons/gloget_logo-trans.png'"
      class="w-[96px]"
      alt="Glo logo"
    />
  </button>
  <div class="flex flex-end py-1 p-0 md:hidden">
    <img [src]="assetUrl + 'icons/menu.svg'" />
  </div>
</div>
